import React, { useState } from "react";
import DatePicker from "react-date-picker";
import styled from "styled-components";
import "react-date-picker/dist/DatePicker.css";
import "react-calendar/dist/Calendar.css";
import { ReactComponent as CalendarIcon } from "../../Assets/icons/calendarIcon.svg";
import { useTranslate, useTolgee } from '@tolgee/react';
const BirthdayMenu = ({ value, setValue, format, slim, onboardStyle, noCalendar, transparent }) => {

    const handleCLick = () => {
        setIsMenuOpen(!menuOpen)
    }

    const [menuOpen, setIsMenuOpen] = useState(false);
    const { t } = useTranslate();
    const tolgee = useTolgee();
    const currentLocale = tolgee.getLanguage();
    return (
        <Container slim={slim}>
            <DatePicker
                id="calendar"
                value={value}
                onChange={setValue}
                clearIcon={null}
                isOpen={menuOpen}
                openCalendarOnFocus={true}
                maxDate={new Date()}
                calendarIcon={noCalendar ? null : <CalendarIcon />}
                locale={currentLocale.split("-")[0]}
            >
            </DatePicker>

            {!value &&
                <PlaceHolderWrapper onClick={() => handleCLick()} onboardStyle={onboardStyle} transparent={transparent}>
                    <p>{t('profile.select_birthdate')}</p>
                </PlaceHolderWrapper>}


        </Container >
    );
};

export default BirthdayMenu;

const Container = styled.div`
  display: flex;
  width: 100%;
    position:relative;
    .react-date-picker{
        width:100%;
        color:${({ theme }) => theme.menu.primaryTextColor};
        font-weight:500;
      }
    
      .react-date-picker__wrapper {
        width: 100%;
        border: none;
        padding: ${props => props.slim ? "0" : "14px 16px "};
            color:${({ theme }) => theme.menu.primaryTextColor};
        border-radius: 10px;
        
      }
      .react-date-picker react-date-picker--closed react-date-picker--enabled{
        width:100%;
      }
    
    
      .react-calendar{
        background: ${({ theme }) => theme.menu.enterPhoneNumberBackground};
           border:none;
           border-radius:10px;
       }
           
    .react-calendar__month-view__days__day{
           color:${({ theme }) => theme.menu.primaryTextColor};
    }
    .react-calendar__month-view__days__day--weekend{
        color:red;
    }
    .react-calendar__tile{
        border-radius:10px;
    
    }
        
    .react-calendar__tile--active{
    background:${({ theme }) => theme.menu.selectedTextColor};
    
    }
    .react-calendar__navigation button{
        color:${({ theme }) => theme.menu.selectedTextColor};
    
    }
    .react-calendar__navigation button:enabled:hover, .react-calendar__navigation button:enabled:focus{
      background: ${({ theme }) => theme.menu.enterPhoneNumberBackground};
    
    }
      
    .react-calendar__tile:enabled:hover, .react-calendar__tile:enabled:focus{
        background:${({ theme }) => theme.menu.groupContentBackground};
        color:${({ theme }) => theme.menu.selectedTextColor};
    }
    .react-calendar__year-view__months__month{
        color:${({ theme }) => theme.menu.primaryTextColor};
    }
    .react-calendar__tile--hasActive{
        background:${({ theme }) => theme.menu.selectedTextColor};
    
    }
    .react-date-picker__button svg{
        stroke:${({ theme }) => theme.menu.selectedTextColor};
    }
    .react-calendar__tile--now {
        background:rgba(149, 152, 157, 1);
    }
    .react-calendar__century-view__decades__decade{
          color:${({ theme }) => theme.menu.primaryTextColor};
    }
    .react-calendar__decade-view__years__year{
         color:${({ theme }) => theme.menu.primaryTextColor};
     }
    
    .react-calendar__tile:disabled {
        opacity:0.3;
        background-color:transparent;
    }
    .react-calendar__navigation button:disabled{
        opacity:0.3;
        background-color:unset;
    }
    

`;

const PlaceHolderWrapper = styled.div`
display:flex;
position:absolute;
top:0;
bottom:0;
align-items:center;
border-radius:10px;
padding:${props => props.onboardStyle ? "0 16px" : 0};
background:${({ transparent, theme }) => transparent ? theme.menu.enterPhoneNumberBackground : theme.menu.groupContentBackground};
cursor:pointer;
width:100%;
p{
opacity:0.6;
    font-size: 16px;

    line-height: 22px;
     color: ${({ theme }) => theme.menu.primaryTextColor};
}
`